import type { GiftGuideOccasion } from "@listou/shared/categories";

/**
 * The gift guides' wording: a hub per occasion and a ranked page per category under it.
 * The paths come from GIFT_GUIDES (shared with the sitemap); the route literals are here
 * because typed links need them spelled out.
 */
export type GiftGuide = {
  hub: "/idees-cadeaux-naissance";
  category: "/idees-cadeaux-naissance/$category";
  /** Short name for links and breadcrumbs. */
  label: string;
  /** "de naissance", as it reads after "idées cadeaux". */
  suffix: string;
  h1: string;
  intro: string;
  seoTitle: string;
  seoDescription: string;
};

export const GIFT_GUIDE_PAGES: Record<GiftGuideOccasion, GiftGuide> = {
  birth: {
    hub: "/idees-cadeaux-naissance",
    category: "/idees-cadeaux-naissance/$category",
    label: "Idées cadeaux de naissance",
    suffix: "de naissance",
    h1: "Idées cadeaux de naissance",
    intro:
      "Les cadeaux que les parents mettent sur leurs listes de naissance, rayon par rayon : ce qui sert vraiment les premiers mois, des petits prix aux cadeaux à offrir à plusieurs.",
    seoTitle: "Idées cadeaux de naissance : les envies des parents, rayon par rayon · Listou",
    seoDescription:
      "Des milliers d'idées cadeaux de naissance tirées des listes des parents : gigoteuses, veilleuses, tapis d'éveil, porte-bébés… classées par rayon.",
  },
};
